import React from 'react';

import { ReactComponent as DocumentIcon } from 'assets/attachment.icon.svg';

import useStyles from '../styles';

interface IProps {
  metadata: string;
}

interface IParsedMetadata {
  FileName: string;
  Path?: string;
  Size: number;
  ThumbPath?: string;
  ContentType: string;
}

const MessageWithAttachment: React.FC<IProps> = ({ metadata }) => {
  const parsedMetadata: IParsedMetadata = JSON.parse(metadata);
  const classes = useStyles();

  if (parsedMetadata.ContentType.includes('image')) {
    return (
      <img src={parsedMetadata?.ThumbPath ?? parsedMetadata?.Path} alt={parsedMetadata?.FileName} />
    );
  }
  return (
    <div className={classes.attachment}>
      <DocumentIcon />
      <a href={parsedMetadata.Path}>{parsedMetadata.FileName}</a>
    </div>
  );
};

export default MessageWithAttachment;
